import templateUrl from "emun.auth/register-current-acct.htm";
import controller from "emun.auth/register-current-acct-prompt.controller";

export default {
  controller,
  templateUrl,
  bindings: { 
    hideHeader: "<?", 
    redirectAfterAuthentication: "@",
    userName: "@",
    email: "@",
    retailerId: "@" 
  },
};
